const normalizeBooster = booster => ({
    id: booster.id,
    name: booster.name,
    displayName: booster.display_name,
    description: booster.description,
    isInternal: booster.is_internal,
    executionPattern: booster.execution_pattern,
    useInSera: booster.use_in_sera,
    useInSpf: booster.use_in_spf,
    meta: booster.meta ? {
        taskName: booster.meta.task_name,
        maxTokens: booster.meta.max_tokens,
        modelName: booster.meta.model_name,
        temperature: booster.meta.temperature,
        useThinking: booster.meta.use_thinking,
        maxConcurrency: booster.meta.max_concurrency,
        useGradingReference: booster.meta.use_grading_reference,
        template: booster.meta.template,
        append: booster.meta.append,
        ...booster.meta // Include any other meta fields as-is
    } : null,
    isActive: booster.is_active,
    createdAt: booster.created_at,
    updatedAt: booster.updated_at,
})

const normalizeQuestionRubricBooster = questionRubricBooster => ({
    id: questionRubricBooster.id,
    questionRubricId: questionRubricBooster.question_rubric_id,
    senseBoosterId: questionRubricBooster.sense_booster_id,
    priority: questionRubricBooster.priority,
    enabled: questionRubricBooster.enabled,
    senseBooster: questionRubricBooster.sense_booster ? normalizeBooster(questionRubricBooster.sense_booster) : null,
})

export const normalizeFetchActiveBoostersResponse = response => {
    if (!response || !Array.isArray(response)) return []
    return response.map(normalizeBooster)
}

export const normalizeFetchQuestionRubricBoostersResponse = response => {
    if (!response || !Array.isArray(response)) return []
    return response.map(normalizeQuestionRubricBooster)
}

export const normalizeAddBoosterToQuestionRubricResponse = response => {
    return normalizeQuestionRubricBooster(response)
}

export const normalizeUpdateQuestionRubricBoosterResponse = response => {
    return normalizeQuestionRubricBooster(response)
}